import { getAdSlotOffsiteState } from 'mk2/containers/AdSlotOffsite/AdSlotOffsite.selectors';
import { AdSlotSticky, OwnProps as AdSlotStickyProps } from 'mk2/containers/AdSlotSticky/AdSlotSticky';
import { AppState } from 'mk2/reducers';
import React from 'react';
import { connect } from 'react-redux';
import styles from './AdSlotOffsite.mscss';

interface OwnProps extends AdSlotStickyProps {}

interface StateProps {
    show: boolean;
}

interface DispatchProps {}

type Props = OwnProps & StateProps & DispatchProps;

export class AdSlotOffsite extends React.PureComponent<Props> {
    public render() {
        const { show, ...rest } = this.props;

        if (!show) {
            return null;
        }

        return (
            <div className={styles.AdSlotOffsite}>
                <AdSlotSticky {...rest} />
            </div>
        );
    }
}

function mapStateToProps(state: AppState, ownProps: OwnProps): StateProps {
    const substate = getAdSlotOffsiteState(state);
    return {
        show: substate.show,
    };
}

export default connect<StateProps, DispatchProps, OwnProps>(
    mapStateToProps,
    null,
)(AdSlotOffsite);
